import { effect as _$effect } from "@opentui/solid";
import { createComponent as _$createComponent } from "@opentui/solid";
import { createTextNode as _$createTextNode } from "@opentui/solid";
import { insertNode as _$insertNode } from "@opentui/solid";
import { insert as _$insert } from "@opentui/solid";
import { memo as _$memo } from "@opentui/solid";
import { setProp as _$setProp } from "@opentui/solid";
import { createElement as _$createElement } from "@opentui/solid";
import { For } from "solid-js";
import { theme } from "../theme";
export function RowDetailModal(props) {
  const currentRow = () => {
    const rows = props.store.rows();
    const index = props.store.selectedRowIndex();
    return rows[index];
  };
  const rowNumber = () => props.store.selectedRowIndex() + 1;
  const totalRows = () => props.store.rows().length;
  return (() => {
    var _el$ = _$createElement("box"),
      _el$2 = _$createElement("box"),
      _el$3 = _$createElement("box"),
      _el$4 = _$createElement("text"),
      _el$5 = _$createElement("span"),
      _el$6 = _$createTextNode(` • Row `),
      _el$8 = _$createTextNode(` of `),
      _el$9 = _$createTextNode(` • j/k navigate • Esc close`),
      _el$1 = _$createElement("scrollbox"),
      _el$10 = _$createElement("box");
    _$insertNode(_el$, _el$2);
    _$setProp(_el$, "position", "absolute");
    _$setProp(_el$, "top", 0);
    _$setProp(_el$, "left", 0);
    _$setProp(_el$, "width", "100%");
    _$setProp(_el$, "height", "100%");
    _$setProp(_el$, "zIndex", 100);
    _$setProp(_el$, "style", {
      backgroundColor: "#000000",
      justifyContent: "center",
      alignItems: "center"
    });
    _$insertNode(_el$2, _el$3);
    _$insertNode(_el$2, _el$1);
    _$setProp(_el$2, "width", "80%");
    _$setProp(_el$2, "height", "80%");
    _$setProp(_el$2, "border", true);
    _$setProp(_el$2, "style", {
      flexDirection: "column"
    });
    _$insertNode(_el$3, _el$4);
    _$setProp(_el$3, "paddingLeft", 1);
    _$setProp(_el$3, "paddingRight", 1);
    _$setProp(_el$3, "borderBottom", true);
    _$insertNode(_el$4, _el$5);
    _$insertNode(_el$4, _el$6);
    _$insertNode(_el$4, _el$8);
    _$insertNode(_el$4, _el$9);
    _$insert(_el$5, () => props.store.selectedTable()?.name || "");
    _$insert(_el$4, rowNumber, _el$8);
    _$insert(_el$4, totalRows, _el$9);
    _$insertNode(_el$1, _el$10);
    _$setProp(_el$1, "stickyScroll", false);
    _$setProp(_el$10, "flexDirection", "column");
    _$setProp(_el$10, "gap", 1);
    _$insert(_el$10, _$createComponent(For, {
      get each() {
        return props.store.columns();
      },
      children: col => {
        const value = () => {
          const row = currentRow();
          return row ? row[col.name] : null;
        };
        const isNull = () => value() === null || value() === undefined;
        const isNum = () => !isNull() && (typeof value() === "number" || !isNaN(Number(value())));
        const displayValue = () => isNull() ? "NULL" : String(value());
        return (() => {
          var _el$11 = _$createElement("box"),
            _el$12 = _$createElement("box"),
            _el$13 = _$createElement("text"),
            _el$14 = _$createElement("box"),
            _el$15 = _$createElement("text");
          _$insertNode(_el$11, _el$12);
          _$insertNode(_el$11, _el$14);
          _$setProp(_el$11, "flexDirection", "column");
          _$insertNode(_el$12, _el$13);
          _$setProp(_el$12, "paddingLeft", 1);
          _$setProp(_el$12, "paddingTop", 1);
          _$insert(_el$13, () => col.name);
          _$insertNode(_el$14, _el$15);
          _$setProp(_el$14, "paddingLeft", 1);
          _$setProp(_el$14, "paddingRight", 1);
          _$setProp(_el$14, "paddingBottom", 1);
          _$insert(_el$15, displayValue);
          _$effect(_p$ => {
            var _v$8 = {
                fg: theme.colors.textDim
              },
              _v$9 = theme.colors.backgroundAlt,
              _v$0 = {
                fg: isNull() ? theme.colors.null : isNum() ? theme.colors.number : theme.colors.textBright
              };
            _v$8 !== _p$.e && (_p$.e = _$setProp(_el$13, "style", _v$8, _p$.e));
            _v$9 !== _p$.t && (_p$.t = _$setProp(_el$14, "backgroundColor", _v$9, _p$.t));
            _v$0 !== _p$.a && (_p$.a = _$setProp(_el$15, "style", _v$0, _p$.a));
            return _p$;
          }, {
            e: undefined,
            t: undefined,
            a: undefined
          });
          return _el$11;
        })();
      }
    }));
    _$effect(_p$ => {
      var _v$ = theme.colors.borderActive,
        _v$2 = theme.colors.background,
        _v$3 = theme.colors.backgroundAlt,
        _v$4 = {
          borderColor: theme.colors.border
        },
        _v$5 = {
          fg: theme.colors.textDim
        },
        _v$6 = {
          fg: theme.colors.text
        },
        _v$7 = {
          flexGrow: 1,
          rootOptions: {
            backgroundColor: theme.colors.background,
            padding: 2
          },
          scrollbarOptions: {
            showArrows: true
          }
        };
      _v$ !== _p$.e && (_p$.e = _$setProp(_el$2, "borderColor", _v$, _p$.e));
      _v$2 !== _p$.t && (_p$.t = _$setProp(_el$2, "backgroundColor", _v$2, _p$.t));
      _v$3 !== _p$.a && (_p$.a = _$setProp(_el$3, "backgroundColor", _v$3, _p$.a));
      _v$4 !== _p$.o && (_p$.o = _$setProp(_el$3, "style", _v$4, _p$.o));
      _v$5 !== _p$.i && (_p$.i = _$setProp(_el$4, "style", _v$5, _p$.i));
      _v$6 !== _p$.n && (_p$.n = _$setProp(_el$5, "style", _v$6, _p$.n));
      _v$7 !== _p$.s && (_p$.s = _$setProp(_el$1, "style", _v$7, _p$.s));
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined,
      o: undefined,
      i: undefined,
      n: undefined,
      s: undefined
    });
    return _el$;
  })();
}